module.exports = __webpack_public_path__ + "e-learning-app/static/img/head2.022d61f.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-area/img/ne/head2.png
// module id = /+P+
// module chunks = 1